module.exports = __webpack_public_path__ + "img/流体力学6_5.8a00eeb0.jpg";